import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { CrossFlowProvider } from '@trello/cross-flow';
import { ErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyDiscoveryAdPowerUp: FunctionComponent<{
  source: string;
  workspaceId?: string;
}> = ({ source, workspaceId }) => {
  const DiscoveryAdPowerUp = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "discovery-ad-power-up" */ './DiscoveryAdPowerUp'
      ),
    { preload: false, namedImport: 'DiscoveryAdPowerUp' },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-web-eng',
          feature: 'Discovery Ad Powerup',
        }}
      >
        <CrossFlowProvider>
          <DiscoveryAdPowerUp source={source} workspaceId={workspaceId} />
        </CrossFlowProvider>
      </ErrorBoundary>
    </Suspense>
  );
};
